var _defs, _circle, _circle2, _circle3, _circle4, _text, _circle5, _circle6, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7b3dbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#4a2275"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 90,
    fill: "url(#gradient)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 120,
    r: 20,
    fill: "#ffd700",
    stroke: "#e6b800",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 20,
    fill: "#ffd700",
    stroke: "#e6b800",
    strokeWidth: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 80,
    r: 20,
    fill: "#ffd700",
    stroke: "#e6b800",
    strokeWidth: 2
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 106,
    fontFamily: "Arial",
    fontSize: 40,
    fontWeight: "bold",
    textAnchor: "middle",
    fill: "#5c2d91"
  }, "$")), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 140,
    r: 10,
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 4
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 140,
    r: 10,
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65 130 L135 130 L140 140 L60 140 Z",
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70 145 L130 145 L130 150 L70 150 Z",
    fill: "#ffffff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M150 70 L170 70",
    stroke: "#ffffff",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M155 55 L175 55",
    stroke: "#ffffff",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M150 85 L170 85",
    stroke: "#ffffff",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a609fefa34d6403fd35cecf4251a56e8.svg";
export { ForwardRef as ReactComponent };